export default __webpack_public_path__ + "ede7428b3f901cfbdad79de47f960459.svg";